module.exports = __webpack_public_path__ + "img/konvey.c0053286.png";